import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { GameManager } from "../GameManager";

export class CheatMenu extends Phaser.Group {

    constructor(game: Phaser.Game) {

        super(game, null, "cheat-menu", false);

        this.scale.y = GameVars.scaleY;

        const tmpVictoryButton = new Phaser.Button( this.game, 50, 5, "texture_atlas_4", this.onClickVictory, this);
        tmpVictoryButton.setFrames("tmp_win_button_on", "tmp_win_button_off", "tmp_win_button_on");
        this.add(tmpVictoryButton);

        const tmpDrawButton = new Phaser.Button ( this.game, 150, 5, "texture_atlas_4", this.onClickDraw, this);
        tmpDrawButton.setFrames("tmp_draw_button_on", "tmp_draw_button_off", "tmp_draw_button_on");
        this.add(tmpDrawButton);

        const tmpDefeatButton = new Phaser.Button ( this.game, 250, 5, "texture_atlas_4", this.onClickDefeat, this);
        tmpDefeatButton.setFrames("tmp_lose_button_on", "tmp_lose_button_off", "tmp_lose_button_on");
        this.add(tmpDefeatButton);
    }

    private onClickVictory(): void {

        if (GameVars.isTimedLevel) {
            this.game.time.events.resume();
        }

        const playerGoals = GameVars.adversaryGoals + Math.floor(Math.random() * 8) + 1;

        GameVars.playerGoals = playerGoals;
        GameVars.matchResult = GameConstants.VICTORY;

        GameManager.onMatchEnded();
    }

    private onClickDraw(): void {

        if (GameVars.isTimedLevel) {
            this.game.time.events.resume();
        }

        GameVars.playerGoals = GameVars.adversaryGoals;
        GameVars.matchResult = GameConstants.DRAW;

        GameManager.onMatchEnded();
    }

    private onClickDefeat(): void {

        if (GameVars.isTimedLevel) {
            this.game.time.events.resume();
        }

        GameVars.playerGoals = Math.floor(Math.random() * (GameVars.adversaryGoals - 1));
        GameVars.matchResult = GameConstants.DEFEAT;

        GameManager.onMatchEnded();
    }
}
